import React, { useContext, useEffect, useState } from 'react'
import { Card, Tag, Button, Avatar, Tooltip, Dropdown, Menu, Input } from 'antd'
import {
  PaperClipOutlined,
  FilePdfOutlined,
  DownOutlined,
  DownloadOutlined,
} from '@ant-design/icons'
import { GET_USERS_FOR_SELECT } from 'modules/Users/graphql/Queries'
import { canUserDownload } from 'utils/User'
import DocumentViewerModal from 'components/DocumentViewerModal'


import './TickDetails.css'
import client from 'apollo'
import { NEW_UPDATE_TICKET } from '../graphql/Mutations'
import openNotification from 'utils/Notification'
import moment from 'moment'
import { AppContext } from 'AppContext'
import { GET_PRIORITY_SLA_CONFIG } from '../graphql/Queries'
import JSZip from 'jszip'
import { GET_TICKET_USERS } from '../Settings/graphql/Queries'
import { uniqBy } from 'lodash'
import CloseTicketDrawer from './ticketCloseDrawer'
import TicketReopenModel from './TicketReopenModel'

// const ticket = {
//   id: '#2456',
//   status: 'High',
//   type: 'Investment Reversal Issue',
//   sla: '2 hrs left',
//   segment: 'HNI',
//   dept: 'Advisory',
//   client: 'KNI-023',
//   rm: 'Rahul Mehta',
//   description: 'Client claims an erroneous investment order placed.',
//   attachments: [
//     { name: 'A1.pdf' },
//     { name: 'dasdas.csv' },
//     { name: 'A1.CSV' },
//     { name: 'A1.CSV' },
//     { name: 'A1.pdf' },
//     { name: 'dasdas.csv' },
//     { name: 'A1.CSV' },
//     { name: 'A1.CSV' },
//   ],
//   activityLogs: [
//     '10:32 AM Ticket Created by Client',
//     '10:35 AM Categorized as Advisory',
//     '10:40 AM SLA set to 4 hrs',
//   ],
//   assignee: 'Jayesh Pithadiya',
// }
const priorityColor = {
  high: 'red',
  medium: 'orange',
  low: 'green',
}

// Status color mapping
const getStatusColor = (status) => {
  const statusColors = {
    OPEN: '#3E97FF', // Blue
    TRIAGED: '#3E97FF', // Blue
    ASSIGNED: '#3E97FF', // Blue
    INPROGRESS: '#3E97FF', // Blue
    REVIEW: '#3E97FF', // Blue
    RESOLVED: '#00B8D9', // Teal/Dark Green
    BREACHED: '#FF6B35', // Orange
    ESCALATED: '#D9214E', // Dark Red
    CLOSED: '#00B8D9', // Teal/Dark Green
  }
  return statusColors[status] || '#3E97FF' // Default blue
}

export default function TicketDetailsPanel({ ticket, refetch }) {
  console.log(ticket, 'ticket details panel')
  const {
    state: { currentUser, isAdmin, userPermissions, isClient },
  } = useContext(AppContext)

  const canDownload = canUserDownload(userPermissions || currentUser, isClient)
  const [docViewer, setDocViewer] = useState({
    visible: false,
    fileUrl: '',
    title: '',
  })


  console.log('ticket details panel currentUser', currentUser.id)

  const [userData, setUserData] = React.useState([])
  const [slaConfigData, setSlaConfigData] = useState([])
  const [combinedAttachments, setCombinedAttachments] = useState([])
  // const [userLoading, setUserLoading] = React.useState(true)
  // const [userError, setUserError] = React.useState(null)

  // eslint-disable-next-line no-unused-vars
  const [tickets, setTickets] = useState(ticket?.id)
  const [assigneeName, setAssigneeName] = useState(() => {
    const user = ticket?.assignUser
    if (user?.firstName || user?.lastName) {
      return `${user.firstName || ''} ${user.lastName || ''}`.trim()
    }
    return 'Unassigned'
  })
  const [currentTime, setCurrentTime] = useState(moment())

  // Real-time clock update
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment())
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  console.log('ticket assigneeuser', ticket?.assignUser?.id)

  const [assigning, setAssigning] = useState(false)
  const [userSearch, setUserSearch] = useState('')
  const [openDrawer, setOpenDrawer] = useState(false)
  const [openReopenDrawer, setOpenReopenDrawer] = useState(false)
  //const [closeReopenTicketLoading, setCloseReopenTicketLoading] = useState(false)
  const filteredUsers = React.useMemo(() => {
    const term = userSearch.trim().toLowerCase()
    if (!term) return userData || []
    return (userData || []).filter((user) => {
      const name = `${user.firstName || ''} ${user.lastName || ''} ${
        user.role || ''
      }`
        .trim()
        .toLowerCase()
      return name.includes(term)
    })
  }, [userData, userSearch])

  const isCoreParticipant = (user, ticket) => {
    return (
      user.id === ticket.assignUser?.id || // Assignee
      user.role === 'ADMIN' || // Admin
      // user.role === 'CLIENT' || // Client
      user.id === ticket.team?.teamLeader?.id || // Team Leader
      user.id === ticket.department?.head?.id // Department Head
    )
  }

  const status = {
    OPEN: 'OPEN',
    TRIAGED: 'TRIAGED',
    ASSIGNED: 'ASSIGNED',
    INPROGRESS: 'INPROGRESS',
    REVIEW: 'REVIEW',
    RESOLVED: 'RESOLVED',
    BREACHED: 'BREACHED',
    ESCALATED: 'ESCALATED',
    CLOSED: 'CLOSED',
  }
  const filteredStatusOptions =
    currentUser.role === 'ADMIN'
      ? Object.values(status)
      : currentUser.role === 'STAFF'
      ? ['OPEN', 'RESOLVED']
      : Object.values(status).filter((s) => s !== 'CLOSED')

  useEffect(() => {
    if (ticket?.assignUser) {
      const name =
        `${ticket.assignUser.firstName || ''} ${
          ticket.assignUser.lastName || ''
        }`.trim() || 'Unassigned'
      setAssigneeName(name)
    } else {
      setAssigneeName('Unassigned')
    }
  }, [ticket])
  useEffect(() => {
    if (ticket) {
      const fileUrls = ticket.fileUrl || []
      console.log('fileUrls', fileUrls)
      const chatAttachments = ticket.attachments || []
      console.log('chatAttachments', chatAttachments)
      setCombinedAttachments([...fileUrls, ...chatAttachments])
    }
  }, [ticket])

  const isImageFile = (fileNameOrType = '') => {
    return /\.(jpeg|jpg|png|gif|webp|ico|bmp|svg)$/i.test(fileNameOrType)
  }
  const isPDF = (fileName = '') => /\.pdf$/i.test(fileName)

  const calculateRealTimeSLATime = (ticket) => {
    console.log('valticklet', ticket)

    if (!ticket?.duration) {
      return { label: '—', isNegative: false }
    }

    const ticketDurationAt = moment(ticket.duration)
    const slaDeadline = ticketDurationAt.clone()
    const now = currentTime.clone()
    // Calculate remaining time
    const remainingTime = moment.duration(slaDeadline.diff(now))
    const isNegative = remainingTime.asMilliseconds() < 0
    const absoluteTime = moment.duration(
      Math.abs(remainingTime.asMilliseconds())
    )
    const days = absoluteTime.days()
    const hours = String(absoluteTime.hours()).padStart(2, '0')
    const minutes = String(absoluteTime.minutes()).padStart(2, '0')
    const seconds = String(absoluteTime.seconds()).padStart(2, '0')

    let formatted
    if (days > 0) {
      formatted = `${days}d ${hours}:${minutes}:${seconds}`
    } else {
      formatted = `${hours}:${minutes}:${seconds}`
    }

    return {
      label: isNegative ? `-${formatted}` : formatted,
      isNegative,
      rawValue: remainingTime.asMilliseconds(), // For sorting
    }
  }
  const slaTime = calculateRealTimeSLATime(ticket)

  const fetchUsers = () => {
    client
      .query({
        query: GET_USERS_FOR_SELECT,
        variables: {
          where: {
            role: ['STAFF', 'SALES_EXECUTIVE', 'ADMIN'],
            // isForAssignee: true,
            isActive: 'true',
          },
          limit: 100000,
        },
      })
      .then((res) => {
        client
          .query({
            query: GET_TICKET_USERS,
          })
          .then((ticketRes) => {
            setUserData(
              uniqBy(
                [
                  ...ticketRes?.data?.getTicketUsers,
                  ...res?.data?.getUsers?.users,
                ],
                'id'
              )
            )
          })
          .catch((ticketErr) => {
            console.log(ticketErr)
            // setUserError(err)
          })
      })
      .catch((err) => {
        console.log(err)
        // setUserLoading(false)
        // setUserError(err)
      })
  }

  const fetchSLAConfigStatus = async () => {
    try {
      const res = await client.query({
        query: GET_PRIORITY_SLA_CONFIG,
        fetchPolicy: 'network-only',
      })

      const data = res?.data?.getPrioritySlaConfigs || []
      setSlaConfigData(data)
    } catch (err) {
      console.error('Error fetching SLA config:', err)
    }
  }

  const handlePriorityChange = (newPriority) => {
    console.log('Changing priority for ticket:', ticket.id, 'to:', newPriority)
    client
      .mutate({
        mutation: NEW_UPDATE_TICKET,
        variables: {
          id: ticket.id,
          data: { priorityId: +newPriority },
        },
        refetchQueries: [
          {
            query: GET_PRIORITY_SLA_CONFIG,
            fetchPolicy: 'network-only',
          },
        ],
      })
      .then(() => {
        openNotification('success', 'Priority updated successfully')
        refetch()
      })
      .catch((err) => console.error(err))
  }

  useEffect(() => {
    fetchUsers()
    fetchSLAConfigStatus()
  }, [])

  const statusMenu = (
    <Menu
      onClick={({ key }) => {
        updateTicketStatus(key)
      }}
    >
      {filteredStatusOptions.map((statusValue) => (
        <Menu.Item key={statusValue}>{statusValue}</Menu.Item>
      ))}
    </Menu>
  )

  // Status update function
  const updateTicketStatus = (newStatus) => {
    client
      .mutate({
        mutation: NEW_UPDATE_TICKET,
        variables: { data: { status: newStatus }, id: ticket.id },
      })
      .then((res) => {
        console.log('Status updated successfully:', res)
        openNotification('success', `Status updated to ${newStatus}`)
        setTickets((prev) => ({ ...prev, status: newStatus }))
        refetch()
      })
      .catch((err) => {
        console.error('Error updating status:', err)
        openNotification('error', 'Failed to update status')
      })
  }

  const assignTicket = (id, data) => {
    const ticketId = data?.id
    setAssigning(true)
    console.log('Assigning ticket...')

    client
      .mutate({
        mutation: NEW_UPDATE_TICKET,
        variables: { data: { assignUserId: parseInt(id) }, id: ticketId },
      })
      .then(() => {
        console.log('Mutation successful')
        const updatedUser = userData.find((u) => u.id === parseInt(id))
        if (updatedUser) {
          const name = `${updatedUser.firstName || ''} ${
            updatedUser.lastName || ''
          }`.trim()
          setAssigneeName(name)
        }

        openNotification('success', 'Ticket Assigned Successfully')
        console.log('Calling refetchTicket...')
        refetch()
      })
      .catch((err) => {
        console.error('Mutation error:', err)
      })
      .finally(() => {
        console.log('Finished assigning')
        setAssigning(false)
      })
  }

  const statusStyleMap = {
    NEW: { bg: '#FBBC041A', color: '#FBBC04' },
    OPEN: { bg: '#3E97FF1A', color: '#3E97FF' },
    ASSIGNED: { bg: '#ECF5FF', color: '#3E97FF' },
    BREACHED: { bg: '#FB7B041A', color: '#FB7B04' },
    ESCALATED: { bg: '#AF00001A', color: '#AF0000' },
    RESOLVED: { bg: '#13806C1A', color: '#13806C' },
    CLOSED: { bg: '#E0E0E0', color: '#757575' },
  }
  const key = (ticket?.status || '').toUpperCase()
  const tagStyle = statusStyleMap[key] || { bg: '#D9D9D9', color: '#000' }

  // const closeTicket = () => {
  //   const ticketId = ticket?.id
  //   if (!ticketId) return
  //   setAssigning(true)

  //   client
  //     .mutate({
  //       mutation: NEW_UPDATE_TICKET,
  //       variables: { data: { status: 'CLOSED' }, id: ticketId },
  //     })
  //     .then(() => {
  //       openNotification('success', 'Ticket Closed Successfully')
  //       refetch()
  //     })
  //     .catch((err) => {
  //       console.error('Error closing ticket:', err)
  //       openNotification('error', 'Failed to close the ticket')
  //     })
  //     .finally(() => {
  //       console.log('Finished closing')
  //       setAssigning(false)
  //     })
  // }

  const Close_ReopenTicket = (payload) => {
    console.log('payload', payload)

    const ticketId = ticket?.id
    if (!ticketId) return
    setAssigning(true)
    setOpenDrawer(true)
    // setCloseReopenTicketLoading(true);

    // client
    //   .mutate({
    //     mutation: NEW_UPDATE_TICKET,
    //     variables: { data: payload, id: ticketId }, // ✅ dynamic payload
    //   })
    //   .then(() => {
    //     openNotification(
    //       'success',
    //       payload.status === 'REOPEN'
    //         ? 'Ticket Reopened Successfully'
    //         : 'Ticket Closed Successfully'
    //     );
    //     refetch();
    //     if (payload.status === 'CLOSED') {
    //       setOpenDrawer(true);
    //     }
    //   })
    //   .catch((err) => {
    //     console.error('Error updating ticket:', err);
    //     openNotification('error', 'Failed to update the ticket');
    //   })
    //   .finally(() => {
    //     console.log('Finished update');
    //     setCloseReopenTicketLoading(false);
    //     setAssigning(false);
    //   });
  }
  const handleCloseFunction = async (payload) => {
    if (payload === 'CLOSED') {
      Close_ReopenTicket({ status: payload })
    } else {
      setOpenReopenDrawer(true)
    }
  }

  // const downloadReport = () => {
  //   console.log('Clicked the download report')
  // }

  // Priority dropdown menu
  const priorityMenu = (
    <Menu
      onClick={({ key }) => {
        const selectedConfig = slaConfigData.find(
          (cfg) => cfg.priorityLevel === key
        )
        if (selectedConfig) {
          handlePriorityChange(selectedConfig.id)
        }
      }}
    >
      {slaConfigData.map((item) => (
        <Menu.Item key={item.priorityLevel}>{item.priorityLevel}</Menu.Item>
      ))}
    </Menu>
  )

  const getCurrentPriorityValue = () => {
    const config = slaConfigData.find(
      (cfg) => String(cfg.id) === String(ticket?.priority?.id)
    )
    return config?.priorityLevel || 'Priority not decided'
  }

  const currentPriorityValue = getCurrentPriorityValue()
  const getSLAColor = (ticket) => {
    const currentLevel = ticket?.currentLevel
    console.log('currentLevel', currentLevel)

    if (!currentLevel) {
      return { background: '#7E82991A', color: '#7E8299' }
    }

    switch (currentLevel) {
      case 'TEAM_LEADER':
        return { background: '#7E82991A', color: '#7E8299' }
      case 'DEPARTMENT_HEAD':
        return { background: '#FB7B041A', color: '#FB7B04' }
      case 'CRM_ADMIN':
        return { background: '#AF00001A', color: '#AF0000' }
      default:
        return { background: '#7E82991A', color: '#7E8299' }
    }
  }
  const slaColor = getSLAColor(ticket)
  // const icon =
  //   currentPriorityValue.toLowerCase() === 'high' ||
  //   currentPriorityValue.toLowerCase() === 'medium'
  //     ? '⚠️'
  //     : currentPriorityValue.toLowerCase() === 'low'
  //     ? '✓'
  //     : ''

  const downloadInZip = (files, ticketNumber) => {
    console.log('Downloading files in zip:', files, ticketNumber)
    if (files?.length) {
      const zip = new JSZip()
      const promises = []

      files.forEach((url) => {
        const filename = url.substring(url.lastIndexOf('/') + 1)
        promises.push(
          fetch(url)
            .then((response) => response.blob())
            .then((blob) => zip.file(filename, blob))
        )
      })

      Promise.all(promises)
        .then(() => zip.generateAsync({ type: 'blob' }))
        .then((content) => {
          const zipFilename = `Attachment of ${ticketNumber}`
          const url = window.URL.createObjectURL(content)
          const a = document.createElement('a')
          a.href = url
          a.download = zipFilename
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch((error) => console.log('Error zipping PDF files:', error))
    } else {
      openNotification('warning', 'No attachment found for this ticket.')
    }
  }

  return (
    <Card
      className='ticket-details-panel'
      style={{ height: '100%', overflowY: 'auto' }}
      bodyStyle={{ padding: 0 }}
    >
      <div
        className='ticket-details-header'
        style={{ display: 'flex', flexWrap: 'nowrap', gap: '20px' }}
      >
        <div style={{ flex: '1 1 auto', minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 10 }}>
            #{ticket.ticketNumber}
          </div>
          <div style={{ color: '#888', fontSize: 13, marginBottom: 4 }}>
            Dept: {ticket?.department?.departmentName} &nbsp;
          </div>
        </div>
        <div style={{ flex: '0 0 auto', textAlign: 'right' }}>
          {currentUser?.role !== 'CLIENT' && (
            <div
              style={{ textAlign: 'left', marginBottom: 10 }}
              className='ticketdetails-priority-buttons-contain'
            >
              {isCoreParticipant(currentUser, ticket) ? (
                <Dropdown overlay={priorityMenu} trigger={['click']}>
                  <Tag
                    color={priorityColor[currentPriorityValue?.toLowerCase()]}
                    onFocus={(e) => (e.target.style.outline = 'none')}
                    className='no-outline:focus'
                    style={{
                      fontWeight: 600,
                      fontSize: 14,
                      borderRadius: '4px',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      padding: '0px 6px',
                      cursor: 'pointer',
                      background: 'none',
                      outline: 'none',
                      minWidth: '100px',
                    }}
                  >
                    <span
                      style={{
                        width: '10px',
                        height: '5px',
                        marginRight: '2px',
                        borderRadius: '50%',
                        backgroundColor: 'currentColor',
                        opacity: 0.8,
                      }}
                    />
                    {currentPriorityValue}
                    <DownOutlined
                      style={{ fontSize: 10, color: '#999', marginLeft: '2px' }}
                    />
                  </Tag>
                </Dropdown>
              ) : (
                <Tag
                  color={priorityColor[currentPriorityValue?.toLowerCase()]}
                  onFocus={(e) => (e.target.style.outline = 'none')}
                  className='no-outline:focus'
                  style={{
                    fontWeight: 600,
                    fontSize: 14,
                    borderRadius: '4px',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '0px 6px',
                    cursor: 'pointer',
                    background: 'none',
                    outline: 'none',
                    minWidth: '100px',
                  }}
                >
                  <span
                    style={{
                      width: '10px',
                      height: '5px',
                      marginRight: '2px',
                      borderRadius: '50%',
                      backgroundColor: 'currentColor',
                      opacity: 0.8,
                    }}
                  />
                  {currentPriorityValue}
                </Tag>
              )}
            </div>
          )}
          {currentUser?.role !== 'CLIENT' && (
            <div className='ticketdetails-assign-buttons-contain'>
              {ticket.status === 'RESOLVED' || ticket.status === 'CLOSED' ? (
                <div style={{ color: slaColor.color, fontSize: 13 }}></div>
              ) : (
                <div style={{ color: slaColor.color, fontSize: 13 }}>
                  SLA: {slaTime.label}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className='ticket-details-content ' style={{ overflowY: 'auto' }}>
        <div className='ticket-details-section'>
          <div
            style={{
              fontWeight: 600,
              marginBottom: 8,
              fontSize: '24px',
              lineHeight: '26px',
              color: '#181C32',
            }}
          >
            Client Details
          </div>
          <div
            style={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}
          >
            <Avatar style={{ backgroundColor: '#AF0000', marginRight: 8 }}>
              {ticket.generateFor?.firstName?.charAt(0)}
            </Avatar>
            <span
              style={{ fontWeight: 500, fontSize: '14px', lineHeight: '24px' }}
            >{`${ticket.generateFor?.firstName} ${ticket.generateFor?.lastName}`}</span>
          </div>
          <div style={{ color: '#888', fontSize: 13, marginBottom: 4 }}>
            Contact Detail: {ticket?.contactDetail} &nbsp;
          </div>
        </div>
        <div className='ticket-details-section'>
          <div
            style={{
              fontWeight: 600,
              marginBottom: 8,
              fontSize: '24px',
              lineHeight: '26px',
              color: '#181C32',
            }}
          >
            Ticket Description
          </div>
          <div
            style={{
              color: '#858585',
              fontSize: 14,
              fontWeight: 400,
              margin: '20px 0px 10px 0px',
            }}
          >
            {ticket.description}
          </div>
        </div>
        {/* {ticket?.fileUrl?.length > 0 ? (
          <div className='ticket-details-section'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div
                style={{
                  fontWeight: 600,
                  marginBottom: 10,
                  fontSize: '24px',
                  lineHeight: '26px',
                  color: '#181C32',
                }}
              >
                Client Attachments
              </div>
              {canDownload && (
                <div
                  style={{
                    fontSize: '11px',
                    color: '#0054A6',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    downloadInZip(ticket?.fileUrl, ticket?.ticketNumber)
                  }
                >
                  Download all{' '}
                  <DownloadOutlined style={{ width: '14px', height: '14px' }} />
                </div>
              )}
            </div>
            <div className='attachments-grid'>
              {ticket?.fileUrl?.map((file, idx) => {
                const fileName = file.split('/').pop() ?? '';

                return (
                  <div
                    key={idx}
                    className='attachment-item'
                    onClick={() =>
                      setDocViewer({
                        visible: true,
                        fileUrl: file,
                        title: fileName || 'Attachment Preview',
                      })
                    }
                  >
                    <Tooltip title={fileName}>
                      <div className='attachment-preview'>
                        {isImageFile(fileName) ? (
                          <img
                            src={file}
                            alt='attachment'
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        ) : isPDF(fileName) ? (
                          <FilePdfOutlined
                            style={{ fontSize: 24, color: '#AF0000' }}
                          />
                        ) : (
                          <PaperClipOutlined
                            style={{ fontSize: 20, color: '#555' }}
                          />
                        )}
                      </div>
                    </Tooltip>
                    <div className='attachment-filename'>
                      {fileName.slice(0, 10)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          ''
        )} */}
        {combinedAttachments?.length > 0 && (
          <div className='ticket-details-section' style={{ height: '17vh' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  marginBottom: 10,
                  fontSize: '24px',
                  lineHeight: '26px',
                  color: '#181C32',
                }}
              >
                Chat Attachments
              </div>
              {canDownload && (
                <div
                  style={{
                    fontSize: '11px',
                    color: '#0054A6',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    downloadInZip(combinedAttachments, ticket?.ticketNumber)
                  }
                >
                  Download all{' '}
                  <DownloadOutlined style={{ width: '14px', height: '14px' }} />
                </div>
              )}
            </div>
            <div
              className='attachments-grid'
              style={{ height: '12vh', overflowY: 'auto' }}
            >
              {combinedAttachments?.map((file, idx) => {
                const fileName = file.split('/').pop() ?? ''

                return (
                  <div
                    key={idx}
                    className='attachment-item'
                    onClick={() =>
                      setDocViewer({
                        visible: true,
                        fileUrl: file,
                        title: fileName || 'Attachment Preview',
                      })
                    }
                  >
                    <Tooltip title={fileName}>
                      <div className='attachment-preview'>
                        {isImageFile(fileName) ? (
                          <img
                            src={file}
                            alt='attachment'
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        ) : isPDF(fileName) ? (
                          <FilePdfOutlined
                            style={{ fontSize: 24, color: '#AF0000' }}
                          />
                        ) : (
                          <PaperClipOutlined
                            style={{ fontSize: 20, color: '#555' }}
                          />
                        )}
                      </div>
                    </Tooltip>
                    <div className='attachment-filename'>
                      {fileName.slice(0, 10)}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}

        <div
          className='ticket-details-section'
          style={{ position: 'absolute', bottom: '10%' }}
        >
          <div
            style={{
              fontWeight: 600,
              marginBottom: 10,
              fontSize: '24px',
              lineHeight: '26px',
              color: '#181C32',
            }}
          >
            Activity Logs
          </div>
          <div style={{ height: isAdmin ? '25vh' : '15vh', overflowY: 'auto' }}>
            {(ticket.ticketLogs || [])
              .slice()
              .sort(
                (a, b) =>
                  new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0)
              )
              .map((log, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      padding: '4px 0',
                    }}
                  >
                    <div style={{ width: '30px', flexShrink: 0 }}>{idx + 1}.</div>
                    <div>
                      [{moment(log.createdAt).format('DD-MM-YYYY hh:mm A')}]{' '}
                      {log.description}
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>

      {currentUser.role === 'CLIENT' ? (
        <div
          className='ticket-details-footer-client'
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            gap: '8px',
            padding: '8px 16px',
            backgroundColor: '#FFF',
            borderTop: '1px solid #E8E8E8',
            zIndex: 10,
            width: '100%',
          }}
        >
          {/* <Button
            style={{
              height: 40,
              border: '1px solid #D9214E',
              color: '#AF0000',
              backgroundColor: '#FFF5F7',
              fontWeight: 600,
              fontSize: 14,
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              flex: 1,
              minWidth: 0,
            }}
            onClick={downloadReport}
          >
            Download Report <DownloadOutlined />
          </Button> */}

          <Button
            style={{
              height: 40,
              padding: '0 20px',
              backgroundColor: '#AF0000',
              color: '#FFFFFF',
              fontWeight: 600,
              fontSize: 14,
              borderRadius: 8,
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
              minWidth: 0,
              margin: 0,
            }}
            // disabled={ticket?.status === 'CLOSED'}
            // onClick={()=>setOpenDrawer(true)}
            //loading={closeReopenTicketLoading === true}
            onClick={() =>
              handleCloseFunction(
                `${ticket?.status === 'CLOSED' ? 'REOPEN' : 'CLOSED'}`
              )
            }
          >
            {ticket?.status === 'CLOSED' ? 'Re-open' : 'Close Ticket'}
          </Button>
        </div>
      ) : (
        <div
          className='ticket-details-footer-admin'
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            gap: '8px',
            padding: '8px 16px',
            backgroundColor: '#FFF',
            borderTop: '1px solid #E8E8E8',
            zIndex: 10,
            width: '100%',
          }}
        >
          {isCoreParticipant(currentUser, ticket) ? (
            <div
              className='ticket-details-footer-staff'
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                alignItems: 'center',
                gap: '12px',
              }}
            >
              <div
                className='assign-dropdown-container-staff'
                style={{ flex: 1, minWidth: 0 }}
              >
                <Dropdown
                  trigger={['click']}
                  disabled={assigning}
                  onVisibleChange={(visible) => {
                    if (!visible) setUserSearch('')
                  }}
                  overlay={
                    <Menu
                      onClick={({ key }) => {
                        const selectedUser = (userData || []).find(
                          (u) => String(u.id) === key
                        )
                        if (selectedUser) {
                          assignTicket(selectedUser.id, ticket)
                        }
                      }}
                    >
                      <Menu.Item
                        key='__search_staff'
                        disabled
                        style={{ cursor: 'default', background: 'transparent' }}
                      >
                        <div
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          style={{ pointerEvents: 'auto' }}
                        >
                          <Input
                            autoFocus
                            allowClear
                            placeholder='Search agent'
                            className='assignt-agent-container-search-styles'
                            value={userSearch}
                            onChange={(e) => setUserSearch(e.target.value)}
                            style={{ borderRadius: 8 }}
                          />
                        </div>
                      </Menu.Item>
                      <Menu.Divider />
                      {(filteredUsers || []).map((user) => (
                        <Menu.Item
                          key={String(user.id)}
                          style={{ width: '100%' }}
                        >
                          <span
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              width: '100%',
                            }}
                          >
                            <span>
                              {user.firstName} {user.lastName}
                            </span>
                            <span
                              style={{
                                marginLeft: 8,
                                color: '#999',
                                fontStyle: 'italic',
                              }}
                            >
                              ({user.role || 'INTERNAL TEAM'})
                            </span>
                          </span>
                        </Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <Button
                    type='text'
                    style={{
                      justifyContent: 'space-between',
                      background: '#5E62780D',
                      color: '#000',
                      display: 'flex',
                      alignItems: 'center',
                      padding: '0 12px',
                      fontWeight: '600',
                      width: '100%',
                      height: 40,
                      borderRadius: 8,
                    }}
                  >
                    <span
                      style={{
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        maxWidth: 'calc(100% - 16px)',
                        display: 'inline-block',
                      }}
                    >
                      {assigneeName ? assigneeName : 'Unassigned'}
                    </span>
                    <DownOutlined
                      style={{ fontSize: 12, color: '#5E6278', marginLeft: 8 }}
                    />
                  </Button>
                </Dropdown>
              </div>

              <div
                className='status-container-staff'
                style={{
                  flex: 1,
                  minWidth: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                {/* <span
                  style={{
                    padding: '0 8px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100px',
                  }}
                >
                  <b>{ticket.assignee || 'Unassigned'}</b>
                </span> */}
                <Dropdown overlay={statusMenu} trigger={['click']}>
                  <Button
                    style={{
                      height: 40,
                      padding: '0 16px',
                      borderRadius: 8,
                      backgroundColor: getStatusColor(ticket.status),
                      color: '#FFFFFF',
                      border: 'none',
                      fontFamily: 'Public Sans, sans-serif',
                      fontWeight: 600,
                      fontSize: '14px',
                      lineHeight: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flex: 1,
                    }}
                  >
                    {ticket.status || 'Open Ticket'}
                    <DownOutlined style={{ fontSize: 12, marginLeft: 5 }} />
                  </Button>
                </Dropdown>
              </div>
            </div>
          ) : (
            <div
              className='ticket-details-footer-staff-readonly'
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
              }}
            >
              <Tag
                style={{
                  width: '50%',
                  margin: '0',
                  borderRadius: '4px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: '700',
                  // color: tagStyle.color,
                  // backgroundColor: tagStyle.bg,
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px',
                  cursor: 'pointer',
                  justifyContent: 'center',
                }}
              >
                {assigneeName || 'Unassigned'}
              </Tag>
              <Tag
                style={{
                  width: '50%',
                  margin: '0',
                  borderRadius: '4px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: '700',
                  color: tagStyle.color,
                  backgroundColor: tagStyle.bg,
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px',
                  cursor: 'pointer',
                  justifyContent: 'center',
                }}
              >
                {ticket.status}
              </Tag>
            </div>
          )}
        </div>
      )}

      {/* // In TicketDetailsPanel.js */}
      <CloseTicketDrawer
        visible={openDrawer}
        onClose={() => setOpenDrawer(false)}
        closeTicket={Close_ReopenTicket}
        ticketId={ticket?.id}
      />
      <TicketReopenModel
        visible={openReopenDrawer}
        onClose={() => setOpenReopenDrawer(false)}
        closeTicket={Close_ReopenTicket}
      />
      <DocumentViewerModal
        visible={docViewer.visible}
        fileUrl={docViewer.fileUrl}
        title={docViewer.title}
        onClose={() => setDocViewer({ visible: false, fileUrl: '', title: '' })}
        canDownload={canDownload}
        watermark={
          !canDownload
            ? `CONFIDENTIAL AUDIT • ${currentUser?.userName || 'AUDIT'} • ${moment().format('DD-MMM-YYYY')}`
            : ''
        }
      />
    </Card>
  )
}
